
export const translations = {
  pt: {
    nav: {
      units: 'Alojamentos',
      location: 'Localização',
      management: 'Gestão de Imóveis',
      faqs: 'FAQs',
      contact: 'Contactos',
      book: 'Reservar Agora'
    },
    hero: {
      title: 'Alojamentos no coração de Braga',
      subtitle: 'Estadias curtas e médias com o conforto de uma casa e a conveniência de um hotel. No centro de tudo.',
      cta: 'Ver Unidades'
    },
    management: {
      title: 'Maximize a Rentabilidade do seu Imóvel',
      subtitle: 'Gestão integral de Alojamento Local em Braga. Nós tratamos de tudo, você recebe os rendimentos.',
      service1: 'Gestão 360º',
      service1Desc: 'Desde a legalização e fotografia até à limpeza e manutenção contínua.',
      service2: 'Otimização de Preços',
      service2Desc: 'Algoritmos dinâmicos para garantir a ocupação máxima ao melhor preço de mercado.',
      service3: 'Canais de Venda',
      service3Desc: 'Presença premium na Airbnb, Booking.com e reservas diretas no nosso site.',
      ctaForm: 'Solicitar Consultoria Gratuita',
      benefitsTitle: 'Porquê escolher a Casas do Paço?',
      benefit1: 'Transparência Total',
      benefit2: 'Manutenção Preventiva',
      benefit3: 'Legalização e Fiscalidade'
    },
    search: {
      checkin: 'Check-in',
      checkout: 'Check-out',
      guests: 'Hóspedes',
      search: 'Pesquisar'
    },
    home: {
      featured: 'Unidades em Destaque',
      featuredSub: 'Espaços pensados para estadias flexíveis e produtivas.',
      advantages: 'Vantagens da Reserva Direta',
      adv1: 'Sem Taxas de Serviço',
      adv1Sub: 'Reserva direta connosco, sem comissões de plataformas externas.',
      adv2: 'Suporte Personalizado',
      adv2Sub: 'Fale diretamente connosco para qualquer pedido especial.',
      adv3: 'Cancelamento Flexível',
      adv3Sub: 'Políticas de cancelamento mais amigáveis e diretas.',
      locationTitle: 'Braga: Tradição e Modernidade',
      locationText: 'As nossas unidades estão situadas nos pontos mais emblemáticos de Braga, permitindo explorar a pé a Sé, o Arco da Porta Nova e os jardins da Avenida Central.',
      testimonials: 'O que dizem os nossos hóspedes',
      corporate: 'Estadias Corporativas',
      corporateText: 'Wi-Fi de alta velocidade e espaços de trabalho em todas as unidades.',
      pillarLocation: 'Localização',
      pillarLocationValue: 'Coração de Braga',
      pillarAccess: 'Acesso',
      pillarAccessValue: 'Self Check-in 24/7',
      pillarDirect: 'Reserva Direta',
      pillarDirectValue: 'Sem Taxas de Serviço',
      specialistTitle: 'Especialistas em Alojamento de Curta Duração',
      specialistText: 'Entendemos que cada viagem tem um propósito diferente. Por isso, as nossas casas estão equipadas para oferecer a agilidade que uma curta estadia exige sem abdicar do conforto.',
      selfCheckin: 'Self Check-in 24/7',
      selfCheckinText: 'Autonomia total. Receba os seus códigos e entre à hora que desejar.',
      cleaning: 'Limpeza Profissional',
      cleaningText: 'Padrões rigorosos de higienização com produtos certificados.',
      localExp: 'Experiência Local',
      localExpText: 'Recomendações exclusivas para viver Braga como um verdadeiro local.',
      walkingDistance: 'A pé',
      walkingValue: 'Sé Catedral: 2 min',
      poi1: 'Sé de Braga - 2 min a pé',
      poi2: 'Arco da Porta Nova - 1 min a pé',
      poi3: 'Avenida Central - 5 min a pé',
      poi4: 'Bom Jesus do Monte - 10 min de carro'
    },
    unitsList: {
      badge: 'Portfolio',
      title: 'Os nossos Alojamentos',
      subtitle: 'Explore cada unidade, veja a localização e abra a página de detalhes.',
      count: 'Unidades',
      all: 'Todas',
      localMgmt: 'Gestão Local',
      premium: 'Qualidade Premium',
      map: 'Mapa',
      viewAll: 'Ver todos',
      empty: 'Nenhuma unidade disponível com este filtro.',
      details: 'Ver Detalhes',
      room: 'Quarto',
      rooms: 'Quartos',
      highlightMap: 'Destacar no mapa'
    },
    unit: {
      details: 'Ver Detalhes',
      priceFrom: 'Desde',
      perNight: '/noite',
      capacity: 'Pessoas',
      type: 'Tipologia',
      amenities: 'Comodidades',
      policies: 'Políticas da Casa',
      bookingRequest: 'Pedido de Reserva',
      submitRequest: 'Enviar Pedido',
      guestsTitle: 'Nº de Hóspedes',
      shortStayBadge: 'Short Stay Ready'
    },
    captcha: {
      label: 'Verificação Humana',
      question: 'Quanto é',
      success: 'Verificado'
    },
    contact: {
      title: 'Fale Connosco',
      subtitle: 'Dúvidas sobre as nossas unidades? Precisa de ajuda com uma reserva ou tem um pedido especial? Estamos aqui para ajudar.',
      address: 'Endereço',
      phone: 'Telefone / WhatsApp',
      email: 'Email',
      mapTitle: 'Mapa de Braga Interativo',
      mapSub: 'Clique para ver as nossas unidades no Google Maps',
      mapButton: 'Ver no Google Maps'
    },
    footer: {
      description: 'Experiências autênticas no coração de Braga. Alojamentos premium desenhados para o seu conforto.',
      legal: 'Informação Legal',
      terms: 'Termos e Condições',
      privacy: 'Política de Privacidade',
      complaints: 'Livro de Reclamações',
      directBooking: 'Reserva Direta = Sem Taxas'
    },
    common: {
      success: 'Pedido enviado com sucesso! Entraremos em contacto brevemente.',
      error: 'Ocorreu um erro. Por favor tente novamente.',
      back: 'Voltar',
      allRights: 'Todos os direitos reservados.',
      home: 'Página Inicial'
    }
  },
  en: {
    nav: {
      units: 'Properties',
      location: 'Location',
      management: 'Property Management',
      faqs: 'FAQs',
      contact: 'Contact',
      book: 'Book Now'
    },
    hero: {
      title: 'Accommodations in the heart of Braga',
      subtitle: 'Short and medium stays with the comfort of a home and the convenience of a hotel. In the center of it all.',
      cta: 'View Properties'
    },
    management: {
      title: 'Maximize Your Property Profitability',
      subtitle: 'Full Short-Term Rental management in Braga. We handle everything, you collect the income.',
      service1: '360º Management',
      service1Desc: 'From legalization and photography to professional cleaning and ongoing maintenance.',
      service2: 'Price Optimization',
      service2Desc: 'Dynamic algorithms to ensure maximum occupancy at the best market price.',
      service3: 'Sales Channels',
      service3Desc: 'Premium presence on Airbnb, Booking.com and direct bookings on our site.',
      ctaForm: 'Request Free Consulting',
      benefitsTitle: 'Why choose Casas do Paço?',
      benefit1: 'Full Transparency',
      benefit2: 'Preventive Maintenance',
      benefit3: 'Legal & Tax Support'
    },
    search: {
      checkin: 'Check-in',
      checkout: 'Check-out',
      guests: 'Guests',
      search: 'Search'
    },
    home: {
      featured: 'Featured Properties',
      featuredSub: 'Spaces designed for flexible and productive stays.',
      advantages: 'Benefits of Direct Booking',
      adv1: 'No Service Fees',
      adv1Sub: 'Book directly with us, with no third-party platform commissions.',
      adv2: 'Personalized Support',
      adv2Sub: 'Speak directly with us for any special requests.',
      adv3: 'Flexible Cancellation',
      adv3Sub: 'Friendlier and more direct cancellation policies.',
      locationTitle: 'Braga: Tradition and Modernity',
      locationText: 'Our units are located in Braga\'s most iconic spots, allowing you to explore the Cathedral, Arco da Porta Nova and Avenida Central gardens on foot.',
      testimonials: 'What our guests say',
      corporate: 'Corporate Stays',
      corporateText: 'High-speed Wi-Fi and workspaces in all units.',
      pillarLocation: 'Location',
      pillarLocationValue: 'Heart of Braga',
      pillarAccess: 'Access',
      pillarAccessValue: 'Self Check-in 24/7',
      pillarDirect: 'Direct Booking',
      pillarDirectValue: 'No Service Fees',
      specialistTitle: 'Short-Term Stay Specialists',
      specialistText: 'We understand that every trip has a different purpose. That is why our homes are equipped to offer the flexibility a short stay demands without compromising on comfort.',
      selfCheckin: 'Self Check-in 24/7',
      selfCheckinText: 'Full autonomy. Receive your codes and check in whenever you like.',
      cleaning: 'Professional Cleaning',
      cleaningText: 'Rigorous hygiene standards with certified products.',
      localExp: 'Local Experience',
      localExpText: 'Exclusive recommendations to experience Braga like a true local.',
      walkingDistance: 'Walking Distance',
      walkingValue: 'Cathedral: 2 min',
      poi1: 'Braga Cathedral - 2 min walk',
      poi2: 'Arco da Porta Nova - 1 min walk',
      poi3: 'Avenida Central - 5 min walk',
      poi4: 'Bom Jesus do Monte - 10 min drive'
    },
    unitsList: {
      badge: 'Portfolio',
      title: 'Our Properties',
      subtitle: 'Explore each unit, see its location and open the details page.',
      count: 'Units',
      all: 'All',
      localMgmt: 'Local Management',
      premium: 'Premium Quality',
      map: 'Map',
      viewAll: 'View all',
      empty: 'No units available with this filter.',
      details: 'View Details',
      room: 'Bedroom',
      rooms: 'Bedrooms',
      highlightMap: 'Highlight on map'
    },
    unit: {
      details: 'View Details',
      priceFrom: 'From',
      perNight: '/night',
      capacity: 'Guests',
      type: 'Type',
      amenities: 'Amenities',
      policies: 'House Policies',
      bookingRequest: 'Booking Request',
      submitRequest: 'Send Request',
      guestsTitle: 'Number of Guests',
      shortStayBadge: 'Short Stay Ready'
    },
    captcha: {
      label: 'Human Verification',
      question: 'How much is',
      success: 'Verified'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Questions about our units? Need help with a booking or have a special request? We are here to help.',
      address: 'Address',
      phone: 'Phone / WhatsApp',
      email: 'Email',
      mapTitle: 'Interactive Braga Map',
      mapSub: 'Click to view our units on Google Maps',
      mapButton: 'View on Google Maps'
    },
    footer: {
      description: 'Authentic experiences in the heart of Braga. Premium accommodations designed for your comfort.',
      legal: 'Legal Information',
      terms: 'Terms and Conditions',
      privacy: 'Privacy Policy',
      complaints: 'Complaints Book',
      directBooking: 'Direct Booking = No Fees'
    },
    common: {
      success: 'Request sent successfully! We will contact you shortly.',
      error: 'An error occurred. Please try again.',
      back: 'Back',
      allRights: 'All rights reserved.',
      home: 'Home'
    }
  }
};
